import { TokenResponse } from 'api/unauth/auth/dtos';
import queryString from 'query-string';
import routes from 'routes';
import { pickBy } from 'utils';
import { ApiSourceEnum } from './dtos';

export const addAuthorizationHeader = (headers: Headers) => {
  const token = localStorage.getItem('access_token');

  if (!token) {
    document.location.href = routes.auth.getAbsolute();
    throw new Error('Access token not found.');
  }

  headers.append('Authorization', `Bearer ${token}`);

  return headers;
};

export const parseUrl = (
  source: ApiSourceEnum,
  url: string,
  businessId?: number,
  parameters?: Record<string, unknown>,
) => {
  const urlWithBusinessId = source + (businessId ? `business/${businessId}/${url}` : url);

  const baseUrl = import.meta.env.VITE_BASE_URL || 'http://localhost';
  const parsedUrl = new URL(`${baseUrl}/${urlWithBusinessId}`);

  parsedUrl.search = queryString.stringify(pickBy(parameters, (x) => x != null && x !== '') || {});

  return parsedUrl.toString();
};

export const refreshToken = async () => {
  const token = localStorage.getItem('refresh_token');

  if (token) {
    const tokenResponse = await fetch(`${import.meta.env.VITE_BASE_URL}/public/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken: token }),
    });

    const response = (await tokenResponse.json()) as TokenResponse;

    if (response?.accessToken && response?.refreshToken) {
      localStorage.setItem('refresh_token', response.refreshToken);
      localStorage.setItem('access_token', response.accessToken);
      return;
    }
  }

  window.location.href = routes.auth.signIn.getAbsolute();
};
